import React from 'react';
import { startOfMonth, endOfMonth, eachDayOfInterval, format } from 'date-fns';
import './Calendar.css';

function Calendar({ images, position, monthImages, startMonth, startDay, language, selectedFrame }) {
  void position;
  const today = new Date();
  let year = today.getFullYear(); // 年を取得

  const months = Array.from({ length: 12 }, (_, i) => (i + startMonth - 1) % 12); // startMonthから開始

  // 曜日ヘッダーの生成を言語に応じて変更
  const weekDaysJapanese = ['日', '月', '火', '水', '木', '金', '土'];
  const weekDaysEnglish = ['Sun.', 'Mon.', 'Tue.', 'Wed.', 'Thu.', 'Fri.', 'Sat.'];
  const weekDays = language === '英語' ? weekDaysEnglish : weekDaysJapanese;

  const orderedWeekDays = weekDays.slice(startDay).concat(weekDays.slice(0, startDay));

  console.log(selectedFrame);

  return (
    <div className="calendar-wrapper">
      <div className={`calendar-scroll frame-${selectedFrame}`}>
        {months.map((monthIndex) => {
          let currentYear = year;
          let currentMonthDate = new Date(currentYear, monthIndex, 1);
          const endOfCurrentMonth = endOfMonth(currentMonthDate);

          if (endOfCurrentMonth < today) {
            currentYear = currentYear + 1;
            currentMonthDate = new Date(currentYear, monthIndex, 1);
          }

          const start = startOfMonth(currentMonthDate);
          const end = endOfMonth(currentMonthDate);
          const days = eachDayOfInterval({ start, end });

          // ユーザ選択の開始曜日に基づいて調整
          const actualStartDay = startDay; // ユーザが選択した開始曜日
          const startWeekday = start.getDay();
          const paddingCount = (startWeekday - actualStartDay + 7) % 7;
          const paddingDays = Array.from({ length: paddingCount }, () => null);

          const monthStr = format(currentMonthDate, 'MM');
          const monthDigits = monthStr.split('');

          const monthNumber = currentMonthDate.getMonth() + 1;
          const currentMonthImage = monthImages[monthNumber];
          const frameFile = require(`../../assets/frames/standard/standard${String(monthNumber).padStart(2, '0')}.PNG`);
          console.log(frameFile);

          return (
            <div key={monthIndex} className="calendar-slide">
              <div 
                className={`flex preview ${selectedFrame === 11 ? 'frame-11' : ''}`}
              >
                {selectedFrame === 0 && (
                  <img 
                    src={frameFile} 
                    alt="frame" 
                    className="frame-image"
                  />
                )}

                {currentMonthImage && (
                  <div className="month-image">
                    <img src={currentMonthImage} alt={`Month ${monthNumber}`} className="pre-image" />
                  </div>
                )}

                <div className="pre-right">
                  <div className="pre-h2">
                    {language === '英語' ? (
                      <>
                        <span className="pre-month-num">
                          {monthDigits.map((digit, index) =>
                            images[digit] ? (
                              <img key={`month-en-${index}`} src={images[digit]} alt={digit} />
                            ) : (
                              <span key={`month-en-${index}`}>{digit}</span>
                            )
                          )}
                        </span>
                        <span className="pre-month">
                          {format(currentMonthDate, 'MMMM')}
                        </span>
                      </>
                    ) : (
                      <span className="pre-month-jp">
                        {monthDigits.map((digit, index) =>
                          images[digit] ? (
                            <img key={`month-${index}`} src={images[digit]} alt={digit} width={20} />
                          ) : (
                            <span key={`month-${index}`}>{digit}</span>
                          )
                        )}
                        月
                      </span>
                    )}
                  </div>
                  <div className="calendar pre-calendar">
                    {orderedWeekDays.map((day, index) => (
                      <div key={`header-${index}`} className="calendar-cell header">
                        {day}
                      </div>
                    ))}
                    {paddingDays.map((_, index) => (
                      <div key={`padding-${index}`} className="calendar-cell empty"></div>
                    ))}
                    {days.map((day) => {
                      const dateNumber = format(day, 'd'); // 日付を数字として取得（先頭にゼロなし）
                      const digits = dateNumber.split('');
                      const isTwoDigits = digits.length > 1;
                      const cellClass = isTwoDigits
                        ? "calendar-cell two-digits"
                        : "calendar-cell";

                      // アップロードされた画像に日付が含まれているかチェック
                      if (images[dateNumber]) {
                        // 日付全体に対応する画像がある場合、その画像を表示
                        return (
                          <div key={day} className={cellClass}>
                            <img src={images[dateNumber]} alt={dateNumber} className="full-date-image" />
                          </div>
                        );
                      } else {
                        // 各桁の数字画像を組み合わせて表示
                        return (
                          <div key={day} className={cellClass}>
                            {digits.map((digit, index) =>
                              images[digit] ? (
                                <img key={index} src={images[digit]} alt={digit} />
                              ) : (
                                <span key={`date-${index}`}>{digit}</span>
                              )
                            )}
                          </div>
                        );
                      }
                    })}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Calendar;
